<template>
  <div style="display: flex">
    <b-row>
      <b-col cols="12">
        <treeselect
            v-model="selectedOptions"
            :multiple="true"
            :options="allOptions"
            :normalizer="Normalizer"
            :load-options="LoadOptions"
            @input="changedSelectedOptions"
            value-consists-of="LEAF_PRIORITY"
        >
          <div slot="value-label" slot-scope="{ node }">
            {{
              isGrouped ? node.raw.group + ': ' + node.raw.text : node.raw.text
            }}
          </div>
          <label
              slot="option-label"
              slot-scope="{ node }"
              class="vue-treeselect__label"
          >
            <span
                v-if="node.id === 'search'"
                class="clickable"
                @click="
                searchModal = true;
                searchFilter = node;
              "
            >search...</span
            >
            <span v-else>{{ node.label }}</span>
          </label>
        </treeselect>
      </b-col>
    </b-row>

    <b-modal v-model="searchModal" title="Search" hide-modal>
      <b-row>
        <b-col cols="12">
          <b-form ref="search-form" @submit.stop.prevent="Search">
            <b-input
                v-show="!searching"
                class="filter-search-input"
                type="search"
                v-model="searchTerm"
                placeholder="Search keyword"
                required
                @focus="
                $event.target.setSelectionRange(0, $event.target.value.length)
              "
            ></b-input>
            <small class="text-muted filter-info"
            >Search to reduce filter's options</small
            >
            <b-icon
                v-show="searching"
                icon="three-dots"
                animation="cylon"
                font-scale="4"
            ></b-icon>
          </b-form>
        </b-col>
      </b-row>
      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="secondary" @click="cancel()">Cancel</b-button>
        <b-button variant="primary" @click="Search">Submit</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import http from '@/mixins/http';
import {LOAD_CHILDREN_OPTIONS} from '@riophae/vue-treeselect';
import _ from "lodash";

export default {
  props: ['value', 'filter', 'selectedCube'],
  mixins: [http],
  data() {
    return {
      allOptions: [],
      searchModal: false,
      searchTerm: '',
      searchFilter: {},
      searching: false,
      selectedOptions: [],
    };
  },
  computed: {
    isGrouped() {
      return _.some(this.filter.options, function (option) {
        return !!(
            option.group &&
            option.group.length > 0 &&
            option.group !== 'All'
        );
      });
    },
    filterOption() {
      return this.filter.options;
    },
    options() {
      let options = [];
      if (this.filter.isHierarchy === true) {
        options = _.chain(this.allOptions)
            .map(function (option) {
              return {
                value: option.value,
                text: option.text,
                options: option.options ? option.options : null,
              };
            })
            .value();
      } else {
        options = this.allOptions;
      }
      return options;
    },
  },
  watch: {
    value: {
      handler(newVal) {
        if (this.selectedOptions !== newVal) this.selectedOptions = newVal;
      },
      deep: true,
    },
    filterOption(newValue) {
      let options = [];
      if (this.filter.isHierarchy === true) {
        options = _.chain(newValue)
            .map(function (option) {
              return {
                value: option.value,
                text: option.text,
                options: option.options ? option.options : null,
              };
            })
            .value();
      } else {
        options = _.cloneDeep(newValue);
      }
      if (options.length >= 100) {
        options.push({
          value: 'search',
          text: '',
          isDisabled: true,
        });
      }

      //options = this.removeOptionForProducts(options);

      this.allOptions = options;
    },
  },
  methods: {
    removeOptionForProducts(options) {
      const valueToRemove = ['KYG', 'CMD', 'AG'];
      return _.filter(options, (o) => {

        return !(valueToRemove.includes(o.text)
            || o.text.startsWith('KYG_')
            || o.text.startsWith('CMD_')
            || o.text.startsWith('AG_'));
      });
    },
    Normalizer(node) {
      return {
        id: node.value,
        label: node.text,
        children: node.options,
      };
    },
    ClearAll() {
      this.$emit('input', []);
    },
    changedSelectedOptions(options) {
      this.$emit('input', options);
    },
    LoadOptions({action, parentNode, callback}) {
      const vm = this;

      if (action === LOAD_CHILDREN_OPTIONS) {
        let levelNumber = parentNode.levelNumber ? parentNode.levelNumber : 1;
        let next = _.find(vm.filter.hierarchies, {
          levelNumber: '' + (levelNumber + 1),
        });
        next.filterId = parentNode.value;
        let nextNext = _.find(vm.filter.hierarchies, {
          levelNumber: '' + (levelNumber + 2),
        });

        vm.axios
            .get('/api/datagrabber/' + vm.selectedCube + '/filteroptions', {
              params: next,
            })
            .then(function (resp) {
              if (resp.data) {
                let options = _.cloneDeep(resp.data.options);
                options = _.map(options, function (v) {
                  if (!v.text || !v.text.trim() || 0 === v.text.length) {
                    v.text = '(null)';
                  }
                  let option = {
                    value: v.value,
                    text: v.text,
                    levelNumber: levelNumber + 1,
                  };
                  if (nextNext) {
                    option.options = null;
                  }
                  return option;
                });
                if (options.length >= 100) {
                  options.push({
                    value: 'search',
                    text: '',
                    isDisabled: true,
                  });
                }

                options = vm.removeOptionForProducts(options);

                parentNode.options = options;
                callback();
              }
            })
            .catch(function (ex) {
              // eslint-disable-next-line no-console
              console.log(ex);
              callback(
                  new Error('Failed to load options: please try again later.')
              );
            });
      }
    },
    Search() {
      const vm = this;
      const form = vm.$refs['search-form'];

      if (!form.reportValidity()) {
        return;
      }

      const levelNumber = vm.searchFilter.levelNumber
          ? vm.searchFilter.levelNumber
          : 1;
      let next = _.find(vm.filter.hierarchies, {
        levelNumber: '' + (levelNumber + 1),
      });

      let level = _.cloneDeep(vm.filter.level);
      level.searchKeyword = vm.searchTerm;
      vm.searching = true;
      vm.axios
          .get('/api/datagrabber/' + vm.selectedCube + '/filteroptions', {
            params: level,
          })
          .then(function (resp) {
            if (resp.data) {
              let existingOptions = _.filter(vm.allOptions, function (a) {
                return vm.CheckSelectedOption(a);
              });
              let options = _.cloneDeep(resp.data.options);
              options = _.map(options, function (v) {
                if (!v.text || !v.text.trim() || 0 === v.text.length) {
                  v.text = '(null)';
                }
                let option = {
                  value: v.value,
                  text: v.text,
                  levelNumber: levelNumber + 1,
                };
                if (next) {
                  option.options = null;
                }
                return option;
              });
              options.push({
                value: 'search',
                text: '',
                isDisabled: true,
              });
              options = [...existingOptions, ...options];

              options = vm.removeOptionForProducts(options);

              if (vm.searchFilter.parentNode) {
                vm.searchFilter.parentNode.options = options;
              } else {
                vm.allOptions = options;
              }
              vm.searchTerm = '';
            }
          })
          .catch(function (ex) {
            // eslint-disable-next-line no-console
            console.log(ex);
          })
          .finally(function () {
            vm.searchModal = false;
            vm.searching = false;
          });
    },
    CheckSelectedOption(obj) {
      const vm = this;
      let exist = false;
      if (obj.options) {
        _.each(obj.options, function (a) {
          exist = exist || vm.CheckSelectedOption(a);
        });
      }
      exist = _.some(vm.selectedOptions, function (selectedOption) {
        return selectedOption === obj.value;
      });
      return exist;
    },
  },
};
</script>

<style lang="scss">
.multiselect__clear {
  position: absolute;
  top: 3px;
  right: 16px;
  height: 40px;
  width: 18px;
  display: block;
  font-size: 1.5em;
  z-index: 2;
  margin-right: 22px;
}

.filter-search-input {
  margin: 0.3rem 0.3rem 0 0;
}

.filter-info {
  margin: auto 0 auto 0.3rem;
}
</style>